import EditTemplate from './edit.html';

export default angular
  .module('main.devices.edit.tabs.edit', [])

  .directive('editDeviceEditTab', () => {
    return {
      restrict: 'E',
      template: EditTemplate,
      scope: {},
      controller: ($scope,
                   $q,
                   $timeout,
                   $filter,
                   utils,
                   ToastsService,
                   I18nService,
                   EditDeviceDataProvider) => {
        const $t = $filter('translate');
        $scope.dataProvider = EditDeviceDataProvider.instance;
        $scope.locale = I18nService.getLocale();
        $scope.loading = true;
        $scope.newDeviceLoading = false;

        angular.extend($scope, {
          onSaveButtonClick: onSaveButtonClick,
          onCancelButtonClick: onCancelButtonClick,
          resetNewDevice: resetNewDevice,
        });

        // #region Form Validation

        $('#editDeviceForm').form({
          inline: true,
          fields: {
            'name': {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.device.desc.empty')
                }
              ]
            }
          }
        });

        // #endregion

        init();

        function init() {
          $q.all([
            $scope.dataProvider.deviceResource.init(),
            $scope.dataProvider.deviceModelsResource.init(),
          ])
            .then(() => {
              $scope.loading = false;
              initWatchers();
            }, (err) => {
              // utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initWatchers() {
          $scope.$watch('dataProvider.deviceResource.value', () => {
            initViewModel();
          }, true);
        }

        function initViewModel() {
          if (!$scope.dataProvider.deviceResource.value) {
            return;
          }

          const deviceModels = $scope.dataProvider.deviceModelsResource.value;
          $scope.deviceModels = deviceModels.map((deviceModel) => {
            return {
              ...deviceModel,
              displayName: deviceModel.name[$scope.locale.code] || deviceModel.name.en,
            };
          });

          $scope.device = angular.copy($scope.dataProvider.deviceResource.value);
          $scope.deviceModelCategory = angular.copy($scope.dataProvider.deviceModelCategoryResource.value);
          $scope.deviceModel = angular.copy($scope.dataProvider.deviceModelResource.value);
          $scope.name = angular.copy($scope.device.desc);
          $scope.canEditDeviceModelId = angular.copy($scope.dataProvider.isUnlimitedAdmin);
          $scope.selectedDeviceModelId = angular.copy($scope.device.modelId);
          $scope.newDevice = angular.copy($scope.device.newDevice);
        }

        function onSaveButtonClick() {
          if ($scope.loading) {
            return;
          }

          $('#form-status').form('validate form');
          if (!$('#form-status').form('is valid')) {
            return $q.reject('Form is not valid');
          }

          $scope.loading = true;
          $scope.dataProvider.saveDeviceInfo($scope.name, $scope.selectedDeviceModelId || undefined)
            .then(() => {
              ToastsService.success();
              $scope.loading = false;
              $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'summary';
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function onCancelButtonClick() {
          $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'summary';
        }

        function resetNewDevice() {
          if ($scope.loading || $scope.newDeviceLoading) {
            return;
          }

          const newDevice = angular.copy($scope.newDevice);
          $scope.newDeviceLoading = true;
          $scope.dataProvider.setNewDevice(!newDevice)
            .then(() => {
              console.log('Start countdown...');
              $timeout(() => {
                console.log('Done!');
                $scope.newDeviceLoading = false;
              }, 3000);
            });
        }
      }
    };
  })
  .name;
